import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"

// Drives the +/-, auto-fill and remove buttons on a Planning::TradeDemandChipComponent.
// All actions are turbo_stream POST/PATCH/DELETE requests that swap the cell back in.
export default class extends Controller {
  static values = {
    url: String, // PATCH/DELETE planning_trade_demand_path(demand)
    autoFillUrl: String, // POST   auto_fill_planning_trade_demand_path(demand)
    count: Number, // required_count in PT (decimal, e.g. 2.5)
  }

  increment() {
    this.adjust(1)
  }

  decrement() {
    this.adjust(-1)
  }

  // Server validates that the new count >= filled — the button is already disabled when
  // hitting the floor, this is the belt-and-braces guard for keyboard activations. The count is
  // decimal PT; rounding to two places keeps 2.4 + 1 from posting 3.4000000000000004.
  adjust(delta) {
    if (!this.hasCountValue) return
    const next = Math.round((this.countValue + delta) * 100) / 100
    if (next <= 0) return

    this.send("PATCH", this.urlValue, { required_count: next }, "adjust")
  }

  autoFill() {
    if (!this.autoFillUrlValue) return
    this.send("POST", this.autoFillUrlValue, {}, "autoFill")
  }

  send(method, url, body, action) {
    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")

    const init = {
      method,
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
    }

    if (method !== "DELETE" && method !== "GET") {
      init.headers["Content-Type"] = "application/json"
      init.body = JSON.stringify(body)
    }

    fetch(url, init)
      .then(async (response) => {
        const html = await response.text()
        const contentType = response.headers.get("Content-Type") || ""
        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)
        } else if (!response.ok) {
          Honeybadger.notify(`Failed (${action}): ${response.status}`, {
            context: { level: "error", component: "planning-trade-demand" },
          })
        }
      })
      .catch((error) => {
        Honeybadger.notify(error, {
          context: { component: "planning-trade-demand", action },
        })
      })
  }
}
